(function (app) {
    app.factory('jobApplyFactory', ["hUser", "hEvent", "JobDetailsBus", function (hUser, hEvent, JobDetailsBus) {
        let jobApplyFactory = {};
        jobApplyFactory.PrepareApplySuccessModal = async (jobIds, status, isMultipleApply) => {
            const defer = $q.defer();
            let returnData = {};
            returnData.isPrivacyShield = hUser.isPrivacyShieldOn();
            returnData.profileScore = 0;
            returnData.WEAK = DashboardAPI.WEAK;
            returnData.GOOD = DashboardAPI.GOOD;
            returnData.MODERATE = DashboardAPI.MODERATE;
            returnData.OUTSTANDING = DashboardAPI.OUTSTANDING;
            returnData.successData = [];
            returnData.completedWotc = status === JobDetailsBus.WOTC_SUCCESS;
            returnData.isMultipleApply = !!isMultipleApply;

            if (!Array.isArray(jobIds)) {
                jobIds = [jobIds];
            }

            for (let jobId of jobIds) {
                if (JobDetailsBus.getIsNoPassword(jobId)) {
                    returnData.isPrivacyShield = false;
                    returnData.isNoPasswordCheck = true;
                    hEvent.track("success_shown", { category: 'job_apply', label: 'no_password' });
                }
            }

            if (!hUser.isLoggedIn()) {
                defer.resolve(returnData);
            }

            try {
                const data = await DashboardAPI.getProfileStrength();
                returnData.profileScore = data.profStrength;
                returnData.profileStrengthCode = data.code;
                returnData.noRecommendations = true;

                for (let jobId of jobIds) {
                    const jobDetails = await JobDetailsBus.getJob(jobId);
                    returnData.successData.push({
                        job: jobDetails.job,
                        brand: jobDetails.brand
                    });
                    returnData.profileSuggestedActions = data.missingItems;
                    hEvent.track("success_shown", { category: 'job_apply', label: 'career_port_' + data.profStrength });
                }
                defer.resolve(returnData);
            } catch (error) {
                console.error(error);
                defer.reject(error);
            }
            return defer.promise;
        };

        jobApplyFactory.showApplySuccessModal = () => {
            $('#apply-success-modal').on('show.bs.modal', () => {
                setTimeout(() => {
                    $('#apply-success-modal').removeClass('before-animation');
                }, 250);
            }).on('hide.bs.modal', () => {
                $('#apply-success-modal').addClass('before-animation');
            }).modal('show');
        }

        return jobApplyFactory;
    }]);

})(angular.module('harriApp'));
